import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = () => {
  const activities = [
  {
    id: 1,
    type: "application",
    title: "Pesticide Application Record",
    description: "Fungicide treatment applied to Field A-12",
    timestamp: new Date(Date.now() - 1800000), // 30 minutes ago
    status: "compliant",
    user: "Marcus Rodriguez",
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16105ed6d-1763296582884.png",
    userAvatarAlt: "Professional headshot of Hispanic man with short dark hair in blue work shirt",
    icon: "Droplets",
    severity: "low"
  },
  {
    id: 2,
    type: "incident",
    title: "Safety Incident Report",
    description: "Minor chemical exposure during mixing process",
    timestamp: new Date(Date.now() - 3600000), // 1 hour ago
    status: "under_review",
    user: "Sarah Chen",
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11fba6733-1763295333276.png",
    userAvatarAlt: "Professional headshot of Asian woman with long black hair in white lab coat",
    icon: "AlertTriangle",
    severity: "medium"
  },
  {
    id: 3,
    type: "certification",
    title: "Organic Certification Renewal",
    description: "Annual organic certification documentation submitted",
    timestamp: new Date(Date.now() - 7200000), // 2 hours ago
    status: "pending",
    user: "David Thompson",
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ecd0e776-1763301015692.png",
    userAvatarAlt: "Professional headshot of Caucasian man with brown hair in green agricultural uniform",
    icon: "Certificate",
    severity: "high"
  },
  {
    id: 4,
    type: "inspection",
    title: "EPA Compliance Inspection",
    description: "Scheduled inspection completed with minor findings",
    timestamp: new Date(Date.now() - 14400000), // 4 hours ago
    status: "action_required",
    user: "Jennifer Walsh",
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1456eb2f9-1763294356174.png",
    userAvatarAlt: "Professional headshot of Caucasian woman with blonde hair in business attire",
    icon: "Search",
    severity: "high"
  },
  {
    id: 5,
    type: "training",
    title: "Safety Training Completed",
    description: "Chemical handling certification training completed",
    timestamp: new Date(Date.now() - 21600000), // 6 hours ago
    status: "completed",
    user: "Michael Johnson",
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7c570ac-1763296079697.png",
    userAvatarAlt: "Professional headshot of African American man with short hair in safety vest",
    icon: "GraduationCap",
    severity: "low"
  }];


  const getStatusColor = (status) => {
    switch (status) {
      case 'compliant':case 'completed':
        return 'text-success bg-success/10';
      case 'pending':case 'under_review':
        return 'text-warning bg-warning/10';
      case 'action_required':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted/10';
    }
  };

  const getSeverityIndicator = (severity) => {
    switch (severity) {
      case 'high':
        return 'border-l-4 border-error';
      case 'medium':
        return 'border-l-4 border-warning';
      case 'low':
        return 'border-l-4 border-success';
      default:
        return 'border-l-4 border-muted';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diffInMinutes = Math.floor((now - timestamp) / (1000 * 60));

    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInMinutes < 1440) {
      return `${Math.floor(diffInMinutes / 60)}h ago`;
    } else {
      return `${Math.floor(diffInMinutes / 1440)}d ago`;
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 agricultural-shadow">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <div className="flex items-center space-x-2">
          <button className="text-sm text-primary hover:text-primary/80 smooth-transition">
            View All
          </button>
          <Icon name="ExternalLink" size={16} className="text-primary" />
        </div>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) =>
        <div
          key={activity?.id}
          className={`p-4 rounded-lg bg-muted/30 ${getSeverityIndicator(activity?.severity)} smooth-transition hover:bg-muted/50`}>

            <div className="flex items-start space-x-4">
              <div className={`p-2 rounded-lg ${getStatusColor(activity?.status)}`}>
                <Icon name={activity?.icon} size={20} />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="font-medium text-foreground truncate">
                    {activity?.title}
                  </h4>
                  <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                    {formatTimeAgo(activity?.timestamp)}
                  </span>
                </div>
                
                <p className="text-sm text-muted-foreground mb-3">
                  {activity?.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <img
                    src={activity?.userAvatar}
                    alt={activity?.userAvatarAlt}
                    className="w-6 h-6 rounded-full object-cover" />

                    <span className="text-sm text-muted-foreground">
                      {activity?.user}
                    </span>
                  </div>
                  
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(activity?.status)}`}>
                    {activity?.status?.replace('_', ' ')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-center">
          <button className="flex items-center space-x-2 text-sm text-primary hover:text-primary/80 smooth-transition">
            <Icon name="RefreshCw" size={16} />
            <span>Refresh Activity Feed</span>
          </button>
        </div>
      </div>
    </div>);

};

export default RecentActivityFeed;